import { render } from "./StaffPicker.vue?vue&type=template&id=335a041d&scoped=true"
import script from "./StaffPicker.vue?vue&type=script&lang=js"
export * from "./StaffPicker.vue?vue&type=script&lang=js"

import "./StaffPicker.vue?vue&type=style&index=0&id=335a041d&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-335a041d"]])

export default __exports__